var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":true}},[_c('div',{staticClass:"mfs-auto"},[_c('span',{staticClass:"mr-1",attrs:{"target":"_blank"}},[_vm._v("Powered by")]),_c('a',{attrs:{"href":"https://morgansolar.com/"}},[_vm._v("Morgan Solar")])])])}
var staticRenderFns = []

export { render, staticRenderFns }